import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function AuthAside() {
  const rungs = [
    { rank: "04", name: "marigold", score: "158,300" },
    { rank: "03", name: "nightraven", score: "171,500" },
    { rank: "02", name: "0xSpeed", score: "179,010" },
    { rank: "🏆", name: "voidwalker", score: "184,220", gold: true },
  ];
  return (
    <aside className="auth-aside">
      <Link to="/"><Logo size={28} /></Link>
      <div className="pitch">
        <span className="eyebrow">Real-time leaderboards as a service</span>
        <h2>Every game has a ladder. Climb it live.</h2>
        <p>
          Fast, dead-simple, no lock-in — and priced for indies. Spin up a board and watch
          your players climb in real time.
        </p>
        <div className="ladder">
          {rungs.map((r, i) => (
            <div
              key={r.name}
              className={`rung ${r.gold ? "gold" : ""}`}
              style={{ animationDelay: `${0.15 + i * 0.09}s`, marginLeft: i * 10 }}
            >
              <b>{r.rank}</b>
              <span className="grow">{r.name}</span>
              <span>{r.score}</span>
            </div>
          ))}
        </div>
      </div>
      <span className="faint mono" style={{ fontSize: 12 }}>
        fully managed · instant ranks · Postgres-durable
      </span>
    </aside>
  );
}
